// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3GZCK","header":"Messages_header__3Gk0Y"};